export const MANAGED_KEY = {
  empty: 1,
  manager: 2,
};

export default {
  MANAGED_KEY,
};
